(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sdlv-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sdlv-navigation')) {
    customElements.define('sdlv-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const close = (focus = false) => { details.open = false; if (focus) summary.focus(); };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-nav-close]')) close(true);
          else if (event.target.closest('a')) close();
        }, options);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, options);
        document.addEventListener('keydown', event => { if (event.key === 'Escape' && details.open) { close(true); event.preventDefault(); } }, options);
        this.addEventListener('focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) close(); }, options);
        window.addEventListener('pageshow', () => close(), options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
